export default {"src":"/_next/static/media/squares-light.a46fea0d.svg","height":297,"width":675,"blurWidth":0,"blurHeight":0};